import { combineReducers } from "redux";

import authReducer from "./authReducer";
import patternReducer from "./patternReducer";
import subscriptionReducer from "./subscriptionReducer";
import teeReducer from "./teeReducer";
import mockupReducer from "./mockupReducer";
import productReducer from "./productReducer";
import interiorDesignReducer from "./interiorDesignReducer";
import linkedinHeadshotReducer from "./linkedinHeadshotReducer";
import outlineReducer from "./outlineReducer";
import imageFilterReducer from "./imageFilterReducer";
import textPosterReducer from "./textPosterReducer";

const reducers = {
    authReducer,
    patternReducer,
    subscriptionReducer,
    teeReducer,
    mockupReducer,
    productReducer,
    interiorDesignReducer,
    linkedinHeadshotReducer,
    outlineReducer,
    imageFilterReducer,
    textPosterReducer,
};

const appReducer = combineReducers(reducers);
const rootReducer = (state, action) => {
    if (action.type === "SIGN_OUT_SUCCESS") {
        state = {};
    }
    return appReducer(state, action);
};

export default rootReducer;
